import React from 'react'
import * as styles from './check_list.module.sass' // eslint-disable-line no-restricted-imports

const CheckList = ({ children }) => <ul className={styles.list}>{children}</ul>

export { CheckList }
